import { render, staticRenderFns } from "./SupplierConfig.vue?vue&type=template&id=4960c7ba&"
import script from "./SupplierConfig.vue?vue&type=script&lang=js&"
export * from "./SupplierConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports